import { StaticImage } from 'gatsby-plugin-image';

const ManifestoVideo = () => {
    return (
        <section className="flex justify-center">
            <StaticImage
                src="./images/mock.png"
                placeholder="blurred"
                alt="Mock Image"
                title="Mock Image"
            />
        </section>
    );
};

export default ManifestoVideo;
